import { render, staticRenderFns } from "./FormRegistrar.vue?vue&type=template&id=ac2c3e62&"
import script from "./FormRegistrar.vue?vue&type=script&lang=js&"
export * from "./FormRegistrar.vue?vue&type=script&lang=js&"
import style0 from "./FormRegistrar.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports